import { createContext, useContext, type PropsWithChildren } from 'react';

import { useFeaturePlaceholder } from './experiments';

import type { UseFeatureHook } from '../types';

type UseFeatureContextValue = UseFeatureHook;

const UseFeatureContext = createContext<UseFeatureContextValue>(
  useFeaturePlaceholder
);

export function UseFeatureProvider({
  children,
  useFeature: useFeatureProp,
}: PropsWithChildren<{ useFeature: UseFeatureHook }>) {
  return (
    <UseFeatureContext.Provider value={useFeatureProp}>
      {children}
    </UseFeatureContext.Provider>
  );
}

export const useFeature: UseFeatureHook = (...args) => {
  const useFeatureFromContext = useContext(UseFeatureContext);

  return useFeatureFromContext(...args);
};
